module.exports = __webpack_public_path__ + "img/icono-xml.8e96f839.svg";